import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { AccessCardDetailsApi } from '../../../middleware/api/EmployeeDirectory/AccessCardDetails/accessCardDetailsApi'
import { RootState } from '../../../stateStore'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import {
  AccessCardDetailsList,
  AccessCardDetailsProps,
  AccessCardPagination,
  AccessCardSliceState,
  EmploymentStatus,
} from '../../../types/EmployeeDirectory/AccessCardDetails/accessCardDetailsTypes'

const getAccessCardsList = createAsyncThunk(
  '/assetManagement/getAccessCardsList',
  async (props: AccessCardDetailsProps, thunkApi) => {
    try {
      return await AccessCardDetailsApi.getAllAccessCardDetails(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const initialAccessCardDetailsState: AccessCardSliceState = {
  accessCardDetailsList: [] as AccessCardDetailsList[],
  selectedCardDetailsList: {} as AccessCardDetailsList,
  selectedEmploymentStatus: EmploymentStatus.active,
  isLoading: ApiLoadingState.idle,
  listSize: 0,
  pagination: {} as AccessCardPagination,
}

const accessCardDetailsSlice = createSlice({
  name: 'accessCardDetails',
  initialState: initialAccessCardDetailsState,
  reducers: {
    setSelectedInternDetails: (state, action) => {
      state.selectedCardDetailsList = action.payload
    },
    changeSelectedEmploymentStatus: (state, action) => {
      state.selectedEmploymentStatus = action.payload as EmploymentStatus
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAccessCardsList.pending, (state) => {
      state.isLoading = ApiLoadingState.loading
    })
    builder.addCase(getAccessCardsList.fulfilled, (state, action) => {
      state.isLoading = ApiLoadingState.succeeded
      state.accessCardDetailsList = action.payload.list
      state.listSize = action.payload.size
    })
    builder.addCase(getAccessCardsList.rejected, (state) => {
      state.isLoading = ApiLoadingState.failed
    })
  },
})

const listSize = (state: RootState): number =>
  state.accessCardDetailsReducer.listSize

const getIsLoading = (state: RootState): LoadingState =>
  state.accessCardDetailsReducer.isLoading

const getAcessCards = (state: RootState): AccessCardDetailsList[] =>
  state.accessCardDetailsReducer.accessCardDetailsList
const selectedEmploymentStatus = (state: RootState): EmploymentStatus =>
  state.accessCardDetailsReducer.selectedEmploymentStatus
export const accessCardDetailsSelector = {
  getAcessCards,
  getIsLoading,
  listSize,
  selectedEmploymentStatus,
}

export const accessDetailsThunk = {
  getAccessCardsList,
}

export const accessCardDetailsService = {
  ...accessDetailsThunk,
  actions: accessCardDetailsSlice.actions,
  selectors: accessCardDetailsSelector,
}
export default accessCardDetailsSlice.reducer
